<template lang="pug">
    r-form(
        ref='form'
        submit-text='guardar'
        title='crear nota de credito'
        v-bind='formProps'
        v-model='formData'
        @reset='reset'
        @submit='submit'
    )
</template>

<script>
    //
    import { mapActions, mapState } from 'vuex'
    import { ModelAutocomplete, RForm } from '@/components/reusable_components/next'
    import TranslatorService from '@/services/translator'
    //
    import PurchaseCreditNoteModel from '@/models/Purchase/PchPurchaseCreditNote'
    import PurchaseCreditNoteFields from '@/views/Purchase/PchPurchaseCreditNote/PchPurchaseCreditNoteFields'
    //
    export default {
        name: 'purchase-credit-note-create',
        components: {
            RForm,
        },
        computed: {

            /**
             * { item_description }
             */
            ...mapState('SnackbarModalModule', ['responseConfirm']),

            /**
             * { function_description }
             *
             * @return     {Object}  { description_of_the_return_value }
             */
            fieldsProps() {
                return {
                    document_type_title: this.fieldsVariant ? 'Documento: Nota de debito' : 'Documento: Factura de compra',
                    pch_provider_branch_offices: this.formData.pch_provider_branch_offices,
                    pch_provider_trigger: this.triggerProvider,
                }
            },

            /**
             * { function_description }
             *
             * @return     {<type>}  { description_of_the_return_value }
             */
            fieldsVariant() {
                return this.formData.document_type
            },

            /**
             * { function_description }
             *
             * @return     {Object}  { description_of_the_return_value }
             */
            formProps() {
                return {
                    fields: PurchaseCreditNoteFields(this.fieldsProps).variant(this.fieldsVariant),
                }
            }
        },
        data() {
            return {
                formData: new PurchaseCreditNoteModel({
                    document_type: 0,
                    pch_provider_branch_offices: [],
                    extra_tax: 0,
                    new_subtotal: 0,
                    iva: 1,
                    total: 0,
                }),
            }
        },
        methods: {

            /**
             * { item_description }
             */
            ...mapActions('MenuesModule', ['setTitleTopBar']),

            /**
             * { item_description }
             */
            ...mapActions('SnackbarModalModule', [
                'setErrorSnackbar',
                'setSuccessSnackbar',
                'setWarningSnackbar',
            ]),

            /**
             * { function_description }
             *
             * @param      {<type>}  error   The error
             */
            error(error) {
                this.setErrorSnackbar(TranslatorService(PurchaseCreditNoteModel, error.response.data))
            },

            /**
             * { function_description }
             */
            redirect() {
                this.$router.push({ name: 'purchase-credit-note-list' })
            },

            /**
             * { function_description }
             *
             * @return     {<type>}  { description_of_the_return_value }
             */
            submit() {
                return this.fieldsVariant ? this.submitCancel() : this.submitCreate()
            },

            /**
             * { function_description }
             *
             * @return     {<type>}  { description_of_the_return_value }
             */
            submitCancel() {
                return this.toWait().then(this.toCancel).then(this.toWait)
            },

            /**
             * { function_description }
             *
             * @return     {<type>}  { description_of_the_return_value }
             */
            submitCreate() {
                return this.toWait().then(this.toCreate).then(this.toWait)
            },

            /**
             * { function_description }
             *
             * @return     {<type>}  { description_of_the_return_value }
             */
            success() {
                return this.setSuccessSnackbar('Nota de credito agregada exitosamente.')
            },

            /**
             * { function_description }
             *
             * @param      {<type>}  model   The model
             * @return     {<type>}  { description_of_the_return_value }
             */
            toCancel(model) {
                return model
                    .cancelPurchaseDebitNote()
                    .attach(model.toCancelPurchaseDebitNote())
                    .then(this.success)
                    .then(this.redirect)
                    .catch(this.error)
            },

            /**
             * { function_description }
             *
             * @param      {<type>}  model   The model
             * @return     {<type>}  { description_of_the_return_value }
             */
            toCreate(model) {
                return model
                    .toCreate()
                    .save()
                    .then(this.success)
                    .then(this.redirect)
                    .catch(this.error)
            },

            /**
             * { function_description }
             *
             * @param      {boolean}  [value=false]  The value
             * @return     {<type>}   { description_of_the_return_value }
             */
            toWait(value = false) {
                return this.$refs.form.setWait(value)
            },

            /**
             * { function_description }
             *
             * @param      {<type>}  ctx     The context
             */
            triggerProvider(ctx) {
                this.formData.pch_provider_branch_offices = ctx
                    .getInput('pch_provider_id')
                    .getSelected()
                    .getProperty('branch_offices', [])
            }
        },
        mounted() {
            this.setTitleTopBar('Crear nota de credito')
        },
        watch: {
            'formData.extra_tax'(val) {
                this.formData.total = Math.round(this.formData.new_subtotal * 1.19) + val
            }
        }
    }
</script>